<!-- eslint-disable vue/no-deprecated-slot-scope-attribute -->
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">All Subscription Users</h5>
                <p class="mb-0 text-sm">
                  Below the list of subscribers.
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="row">
                  <div class="col">
                    <div class="my-auto ms-auto">
                    <div
                      id="import"
                      class="modal fade"
                      tabindex="-1"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog mt-lg-10">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 id="ModalLabel" class="modal-title">
                              Import CSV
                            </h5>
                            <i class="fas fa-upload ms-3"></i>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <p>You can browse your computer for a file.</p>
                            <input
                              type="text"
                              placeholder="Browse file..."
                              class="mb-3 form-control"
                            />
                            <div class="form-check">
                              <input
                                id="importCheck"
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                checked=""
                              />
                              <label
                                class="custom-control-label"
                                for="importCheck"
                                >I accept the terms and conditions</label
                              >
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn bg-gradient-secondary btn-sm"
                              data-bs-dismiss="modal"
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              class="btn bg-gradient-success btn-sm"
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <download-excel
                      class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0"
                      :fetch="fetchData"
                      :fields="json_fields"
                      worksheet="My Worksheet"
                      name="subscribers.xls"
                      :before-generate = "showLoading"
                      :before-finish   = "hideLoading">

                      Export
                    </download-excel>
                  </div>
                </div>                
                </div>                
              </div>
            </div>
            
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive">
              <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns search-results">
                <div class="dataTable-top">
                  <div class="dataTable-dropdown">
                    <label>
                      <select class="dataTable-selector form-select form-select-sm" v-model="limitPerPage" @change="getAllAPI()">
                        <option v-for="item in perPages" :value="item" :key="item" >{{ item }}</option>                        
                      </select>
                      entries per page
                    </label>
                    </div>
                    <div class="dataTable-search">
                      <div class="row">
                        <div class="col-5">
                          <div class="input-daterange datepicker row align-items-center" >
                            <base-input addon-left-icon="ni ni-calendar-grid-58" >
                            <date-range-picker
                                ref="picker"
                                :opens="opts.opens"
                                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                                :singleDatePicker="opts.singleDatePicker"
                                :showWeekNumbers="opts.showWeekNumbers"
                                :showDropdowns="opts.showDropdowns"
                                :autoApply="opts.autoApply"
                                :dateRange="opts.dateRange"
                                v-model="dates.range"
                                :linkedCalendars="opts.linkedCalendars"
                              >
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ dateTime(picker.startDate) }} - {{ dateTime(picker.endDate) }}
                                </template>
                              </date-range-picker>
                            </base-input>
                          </div>
                      
                        </div>
                        <div class="col-2">
                          <select class="dataTable-selector form-select form-select-sm" v-model="filter_by">
                            <option value="" disabled hidden>Search By</option>
                            <option v-for="item in filterOpts" :value="item.value" :key="item.label" >{{ item.label }}</option>                        
                          </select>          
                        </div>
                        <div class="col-3">
                          <input class="dataTable-input form-control" placeholder="Search..." type="text" v-model="search">
                        </div>
                        <div class="col">                                          
                          <button class="rounded btn btn-xs text-white bg-success" @click="getAllAPI()">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  <div class="dataTable-container">
                    <table id="products-list" class="table table-flush dataTable-table">
                      <thead class="thead-light">
                        <tr>
                          <th>
                            No. 
                          </th>
                          <th>
                            Subscription ID
                          </th>
                          <th>
                            Service Name
                          </th>
                          <th>
                            Product Type
                          </th>
                          <th>
                            Full Name
                          </th>
                          <th>
                            Margin In
                          </th>
                          <th>
                            Updated At
                          </th>
                          <th>
                            Status
                          </th>
                          <th>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in records" :key="record.id">
                          <td class="text-sm">{{ ((this.currentPage-1)*this.limitPerPage) + index+1 }}</td>
                          <td class="text-sm">{{ record.id }}</td>
                          <td class="text-sm">{{ record.service_name }}</td>
                          <td class="text-sm">{{ record.pricing_data?.product_type }}</td>
                          <td class="text-sm">{{ record.full_name }}</td>
                          <td class="text-sm">${{ record.margin.id != '' ? record.margin.margin_in : record.balance }}</td>
                          <td class="text-sm">{{ dateTime(record.updated_at) }}</td>
                          <td>
                            <span class="badge badge-danger badge-sm" v-if="record.subscription_status == 'declined'">Declined</span>
                            <span class="badge badge-info badge-sm" v-else-if="record.subscription_status == 'waiting_confirmation'">Approval</span>
                            <span class="badge badge-success badge-sm" v-else>Active</span>
                          </td>
                          <td class="text-sm">
                            <router-link  :to="{ 
                                path: '/subscriptions/'+ record.id +'/edit',
                                query: $route.query  // <- meneruskan query dari route sekarang
                              }" 
                              class="mx-3" data-bs-toggle="tooltip" data-bs-original-title="Edit user">
                              <i class="fas fa-user-edit text-secondary" aria-hidden="true"></i>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dataTable-bottom">
                    <div class="dataTable-info">Showing {{ totalRecords == 0 ? 0 : currentPage }} to {{ shownData() }} of {{  totalRecords }} entries</div>
                      <nav class="dataTable-pagination">
                        <argon-pagination color="success" size="sm">
                          <argon-pagination-item prev v-if="currentPage > 1" @click="onChangePagination(currentPage-1)"/>
                          <argon-pagination-item v-for="item in dataPerPages()" :label="String(item)" :active="item == currentPage" :key="item" @click="onChangePagination(item)"/>
                          <argon-pagination-item next v-if="currentPage < dataPerPages()" @click="onChangePagination(currentPage+1)"/>
                        </argon-pagination>
                      </nav>
                    </div>
                 
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<style>
  .vue-daterange-picker .form-control.reportrange-text{
    padding: 0.5rem 0.75rem !important;    
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border: 1px solid #ccc !important;
  }
  .vue-daterange-picker {
    width: 85%;
  }
  .input-daterange.datepicker .form-group.input-group {
    margin-right:50px;
  }
</style>
  <script>
  import SubscriptionService from "@/services/subscriptions.service.js";
  import ArgonPagination from "@/components/ArgonPagination.vue";
  import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
  import BaseInput from "@/components/BaseInput.vue";
  import showSwalConfirmationDelete from "@/mixins/showSwal.js";
  import { ref } from 'vue';
  import { toast } from 'vue3-toastify';
  import JsonExcel from "vue-json-excel3";
  import DateRangePicker from 'vue3-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  //you need to import the CSS manually


  const toastId = ref('');

  const moment = require('moment');

  export default {
    name: "ExternalUserList",
    data() {
      var startDate = new Date();
      var endDate = new Date();
      const queryParam = this.$route.query
      
      if(queryParam.date_start != undefined && queryParam.date_start != "") {
        startDate = moment(queryParam.date_start, "YYYY-MM-DD").toDate()        
      }else{
        startDate.setDate(startDate.getDate() - 7)
      }

      if(queryParam.date_end != undefined && queryParam.date_end != "") {
        endDate = moment(queryParam.date_end, "YYYY-MM-DD").toDate()        
      }
      
      return {
        filterOpts: [{label: 'Subscription ID', value: 'id'}, {label: 'Customer Code', value: 'user_id'}, {label: 'Product Type', value:'pricing_data.product_type'}],

        opts: {
          dateRange: {startDate,endDate},
          opens: "left",
          minDate: new Date(),
          maxDate: new Date(),
          singleDatePicker: false,
          showWeekNumbers: true,
          autoApply: false,
          linkedCalendars: true,
        },
        dates: {
            range: {startDate: startDate, endDate: endDate}
          },
        perPages: [5, 10, 15, 20, 25],
        records: [],
        totalRecords: 0,        
        limitPerPage: 5,
        currentPage: 1,
        search: '',
        filter_by: '',
        sortBy: {
          name: 'updated_at',
          sortType: '-1'
        },
        json_fields: {
            "ID": "id",
            "Service Name": "service_name",
            "Service Description": "service_description",
            "Product Type": "pricing_data.product_type",
            "Fullname": "full_name",
            "Trading Platform": "trading_platform",
            "Broker Name": "broker_name",
            "Live Server Name": "live_server_name",
            "Meta Account Number": "meta_account_number",
            "Meta Account Password Investor": "meta_account_master_password",
            "Margin In": {
                callback: (value) => {
                    return `$${value.balance}`;
                }
            },
            'Amount' : {
                callback: (value) => {
                    return `RP. ${value.amount}`;
                }
            },
            "Active Until": "active_until",
            "Status": "subscription_status",
            "Updated At": "updated_at",            
          },
      };
    },
    mixins: [showSwalConfirmationDelete],
    methods: {
      async fetchData(){
        const params = {
          limit: 500,
          page: this.currentPage,
          filter: this.search,
          filter_by: this.filter_by,
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate)
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        
        const response = await SubscriptionService.getAllDownload(params);
        console.log(response);
        return response.data.data.subscriptions;
      },
      showLoading(){
        toastId.value = toast.loading('Please wait...');
      },
      hideLoading(){
        setTimeout(() => {
          toast.remove(toastId.value)
        }, 1000); 
      },
      showSuccess(){
        toast.update(toastId.value, {
          render: "delete Successfully",
          closeOnClick: true,
          closeButton: true,
          type: 'success',
          isLoading: false,
          autoClose: 3000
        });      
      },
      showFailed(e){
        toast.update(toastId.value, {
          render: e,
          closeOnClick: true,
          closeButton: true,
          type: 'error',
          isLoading: false,
          autoClose: 3000
        });
      },
      confirmationDelete(id){
        this.showSwalConfirmationDelete().then((result) => {
            console.log(result)
            if (result.value) {
              this.deleteRecord(id)
            }
          });        
      },
      deleteRecord(id){
        this.showLoading()

        SubscriptionService.delete(id).then(() => {
          this.showSuccess()
          this.getAllAPI()
        }).catch(e => {
          this.showFailed(e.response.data.code_message)           
        });
      },
      dateTime(value) {
        return moment(value).format("DD MMM YYYY");
      },
      dateTimeV2(value) {
        return moment(value).format("YYYY-MM-DD");
      },
      shownData() {
        const total = this.limitPerPage*this.currentPage
        return this.totalRecords > total ? total : this.totalRecords
      },
      dataPerPages() {
        const total = Math.ceil(this.totalRecords / this.limitPerPage)
        return total
      },
      onChangePagination(event) {
        this.currentPage = event
        this.getAllAPI()
      },
      getAllAPI(){
        console.log(this.dates)
        const params = {
          limit: this.limitPerPage,
          page: this.currentPage,
          filter: this.search,
          filter_by: this.filter_by,
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate)
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        SubscriptionService.getAll(params).then(e => {
          const data = e.data
          this.records = data.subscriptions
          this.totalRecords = data.count
        })

        // Update query params di route agar bisa diingat
        this.$router.replace({
          path: '/subscriptions',     // sesuaikan path Anda
          query: {
            search: this.search,
            filter_by: this.filter_by,
            limitPerPage: this.limitPerPage,
            currentPage: this.currentPage,
            date_start: this.dateTimeV2(this.dates.range.startDate),
            date_end: this.dateTimeV2(this.dates.range.endDate),
            sortByName: this.sortBy.name,
            sortByType: this.sortBy.sortType
          }
        })
      },      
    },
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      BaseInput,
      DateRangePicker,
      downloadExcel:JsonExcel

    },
    mounted() {
      const { query } = this.$route

      // jika ada query search, restore
      if(query.search){
        this.search = query.search
      }
      if(query.filter_by){
        this.filter_by = query.filter_by
      }
      if(query.limitPerPage){
        this.limitPerPage = parseInt(query.limitPerPage, 10)
      }
      if(query.currentPage){
        this.currentPage = parseInt(query.currentPage, 10)
      }
      if(query.sortByName && query.sortByType){
        this.sortBy.name = query.sortByName
        this.sortBy.sortType = query.sortByType
      }
      // date_start & date_end
      // if(query.date_start && query.date_end){
      //   // parse string ke Date
      //   const start = moment(query.date_start, "YYYY-MM-DD").toDate()
      //   const end = moment(query.date_end, "YYYY-MM-DD").toDate()
      //   this.dates.range.startDate = start
      //   this.dates.range.endDate = end
      // }
      
      this.getAllAPI()
    },
  };
  </script>
  